import { AsyncPipe, DatePipe } from '@angular/common';
import { AfterViewInit, Component, inject, input, viewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';

import { TaskAndAttention } from 'src/app/models/taskAndAttention';
import { UserNamePipe } from 'src/app/pipes/user-name.pipe';
import { UserReplacePipe } from '../../../pipes/user-replace.pipe';
import { AzureIdStatusPipe } from '../../../pipes/azure-id-status.pipe';

@Component({
  selector: 'app-task-view-table',
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    UserNamePipe,
    AsyncPipe,
    DatePipe,
    UserReplacePipe,
    AzureIdStatusPipe
  ],
  templateUrl: './task-view-table.component.html',
  styleUrl: './task-view-table.component.scss'
})
export class TaskViewTableComponent implements AfterViewInit {
  router = inject(Router);
  dataSource = new MatTableDataSource<TaskAndAttention>([]);
  displayedColumns: string[] = [
    'identity',
    'title',
    'priority',
    'deadline',
    'auditor',
    'remark',
    'createdBy',
    'auditee'
  ];

  readonly data = input<TaskAndAttention[]>([]);

  readonly sort = viewChild.required(MatSort);
  readonly paginator = viewChild.required(MatPaginator);

  ngAfterViewInit() {
    this.dataSource.data = this.data();
    this.dataSource.sort = this.sort();
    this.dataSource.paginator = this.paginator();
  }

  navigateTo(entry: TaskAndAttention): void {
    const link = this.getRouterLink(entry);
    this.router.navigateByUrl(link);
  }

  getRouterLink(entry: TaskAndAttention): string {
    if (entry.form === 'BD') {
      return '/audit_detail/' + entry.id;
    } else {
      return '/recommendation_detail/' + entry.id;
    }
  }
}
